import React from "react";
import { useState } from "react";
import { writeContract, getNetwork } from '@wagmi/core'
import { getFirstEditionNFTAddress } from '../../constants/addressBook'
import articleNFTABI from '../../abis/articleNFTABI'
import { adminRole } from "../../constants/roles";

export const AddAdminFirstEditionNFT
: React.FC = () => {
  const [newAdmin, setnewAdmin] = useState("");

  return (
    <div>
      <label>Add a new Admin Permission
      <form>
        <label>New Admin
          <input
            type="text" 
            value={newAdmin}
            onChange={(e) => setnewAdmin(e.target.value)}
          />
        </label>
      </form>
      <button onClick={async () => {
        const network = await getNetwork()
        console.log(network.chain?.name)
        const firstEditionNFTAddress = getFirstEditionNFTAddress(network.chain?.name)
        writeContract({
          address: firstEditionNFTAddress,
          abi: articleNFTABI,
          functionName: "grantRole",
          args: [adminRole, newAdmin]
        })
      }}>Submit</button>
      </label>
      <br/>
      <br/>
    </div>
  )
}